/**
 * Helpers for guest visibility and capacity counts.
 * Used by Guests page, Dashboard, and API.
 */

export interface GuestForCount {
  visible_in_guests?: boolean;
  counts_for_capacity?: boolean;
  plus_one?: boolean;
  kids_count?: number;
}

/** Returns guests that should be shown in the Hosté list (coordinator yes, bride/groom no). */
export function filterVisibleInGuests<T extends GuestForCount>(guests: T[]): T[] {
  return guests.filter(g => g.visible_in_guests !== false);
}

/** Total person count for capacity (strava, activities): 1 + plus_one + kids_count per guest where counts_for_capacity !== false. */
export function countCapacity(guests: GuestForCount[]): number {
  return guests
    .filter(g => g.counts_for_capacity !== false)
    .reduce((sum, g) => sum + 1 + (g.plus_one ? 1 : 0) + (g.kids_count || 0), 0);
}

/** Roles that must not be created via "Přidat hosta" (bride/groom only in Svatební tým). */
export const FORBIDDEN_GUEST_ROLES_VIA_ADD_GUEST = ['bride', 'groom'];

export function isForbiddenRoleForCreateGuest(role: string | undefined): boolean {
  return !!role && FORBIDDEN_GUEST_ROLES_VIA_ADD_GUEST.includes(role);
}
